export default __webpack_public_path__ + "static/product-placeholder-4251e5e2e8d807d239123975be97f0e6.jpg";